import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import api from '../../services/api';
import { useI18n } from '../../i18n/I18nContext';

const ContractsList = () => {
  const { t } = useI18n();
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get('/expediteur/contracts');
        setContracts(res.data || []);
      } catch (e) {
        setError(e.message || t('contracts.errors.loadFailed'));
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [t]);

  return (
    <DashboardLayout>
      <div className="container py-3">
        <h2 className="mb-3">{t('contracts.list.title')}</h2>
        {loading && <p>{t('common.loading')}</p>}
        {error && <div className="alert alert-danger">{error}</div>}
        {!loading && !error && (
          <>
            {contracts.length === 0 ? (
              <p className="text-muted">{t('contracts.list.noContracts')}</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>{t('common.id')}</th>
                      <th>{t('common.name')}</th>
                      <th>{t('common.date')}</th>
                      <th>{t('contracts.list.table.file')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contracts.map((c) => (
                      <tr key={c.id}>
                        <td>{c.id}</td>
                        <td>{c.name || t('contracts.list.defaultName')}</td>
                        <td>{c.createdAt ? new Date(c.createdAt).toLocaleString() : '-'}</td>
                        <td>
                          {c.fileUrl && (
                            <a href={c.fileUrl} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-secondary">
                              {t('common.open')}
                            </a>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ContractsList;
